<template>
  <div class="banner" >
    <a href="#"><img v-for="(item,index) in imgArray"  :key="index"  :src="item" v-show="n==index"/></a>
    <div class="banner-circle">
      <ul class="banner-ul">
        <li v-for="(item,index) in imgArray" :key="index" :class="index==n?'selected':''"
            @click="clickImg(index)"></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "banner",
  data(){
    return {
      n:0,//默认图片是第一张开始
      imgArray:[
        require('@static/img/1.jpeg'),
        require('@static/img/2.jpeg'),
        require('@static/img/3.jpeg'),
        require('@static/img/4.jpeg')
      ],//获取图片位置
    }
  },
  created(){
    this.play()
  },
  methods:{
    play(){
      this.timer = setInterval(this.autoPlay, 5000);//用定时器控制每张图的显示时间
    },
    autoPlay(){
      this.$data.n ++
      if(this.imgArray.length == this.n){
        this.n = 0
      }
    },
    clickImg(index){
      this.n = index   //显示当前点击的图片
    }

  },
  beforeDestroy(){
    clearInterval(this.timer)   //清除定时器
  }
}
</script>

<style scoped>
.banner{
  width: 100%;
  position: relative;
}
.banner img{
  width:100%;
  height: 100%;
}
.banner .banner-circle{
  position: absolute;
  display: block;
  top: 90%;
  left:48%;
}
.banner ul.banner-ul{
  display: flex;
}
.banner .banner-ul li{
  height: 10px;
  width: 10px;
  margin-left: 10px;
  border-radius: 50%;
  border: 2px solid #c4a464;
}
.selected{
  background: #c4a464;
}
@media screen and (max-width:800px){
  .banner .banner-circle{
    position: absolute;
    display: block;
    top: 80%;
    left:43%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue